import Activity from "../../activity/model/Activity";
import WriteMissingWordsContainerModel from "./WriteMissingWordsContainerModel";

class WriteMissingWordsActivity extends Activity {
  constructor() {
    super();
    this.activityType = this.WRITE_MISSING_WORDS;
    this.WriteMissingWordsContainerModel = new WriteMissingWordsContainerModel();
  }

  initFromJson = (obj) => {
    this.initPublicItemsFromJson(obj);
    this.WriteMissingWordsContainerModel.initFromJson(obj.WriteMissingWordsContainerModel);
  };

  getAsJson = () => {
    let obj = this.getPublicItemsAsJson();
    obj.WriteMissingWordsContainerModel = this.WriteMissingWordsContainerModel.getAsJson();

    return obj;
  };


  getReportAsJson = () => {
    let obj = {};
    obj.activityId = this.activityId
    obj.WriteMissingWordsContainerModel = this.WriteMissingWordsContainerModel.getAsJson();
    obj.answeredTrue = this.answeredTrue
    obj.activityType = this.activityType

    return obj;
  };

  initReportFromJson = (obj) => {
    this.activityId = obj.activityId
    this.answeredTrue = obj.answeredTrue
    this.WriteMissingWordsContainerModel=new WriteMissingWordsContainerModel()
    this.WriteMissingWordsContainerModel.initFromJson(obj.WriteMissingWordsContainerModel);
  };

  initFromJsonTest4You = (obj) => {
    this.initPublicItemsFromJsonTest4You(obj);
    this.WriteMissingWordsContainerModel.initFromJsonTest4You(obj.WriteMissingWordsContainerModel);

  }
  initSharedItems = (activityArr) => {
    this.initPublicSharedItem(activityArr);
  };

  getAnsweredTrue = () => {
    let rightAnswers = []
    this.WriteMissingWordsContainerModel.answerList.forEach(element => {
      let rightAns = element.answers.filter(function (answer, index) {
        return answer == element.solvedAnswer
      })
      if (rightAns.length > 0)
        rightAnswers.push(rightAns[0])
    });
    if (rightAnswers.length != this.WriteMissingWordsContainerModel.answerList.length)
      this.answeredTrue = false

  }


  resetActivity = () => {
    this.WriteMissingWordsContainerModel.answerList.forEach(element => {
      element.solvedAnswer = ""
    })
  }
}

export default WriteMissingWordsActivity;
